import React from 'react';
import ReactTooltip from 'react-tooltip';
import * as DateTimeFormatUtils from '../../common/DateTimeFormatUtils';
import { connect } from 'react-redux';
import { isGroupOnly } from '_legacy/utils/Visibility';
import { GROUP_ONLY_TEMPORARY_TYPE_VALUE } from '_legacy/constants/groupOnlyType';

export const generateGroupOnlyTooltip = (data, userTimezone) => {
    if (!(data && isGroupOnly(data.visibility))) {
        return null;
    }

    const isTemporary =
        data.groupOnlyType === GROUP_ONLY_TEMPORARY_TYPE_VALUE ||
        Boolean(data.groupOnlyExpiryDate);

    if (!isTemporary) {
        return `Only visible to ${data.groupName}`;
    }

    const date = DateTimeFormatUtils.formatFullDate(
        data.groupOnlyExpiryDate,
        userTimezone
    );

    return `Only visible to ${data.groupName} until ${date}`;
};

const GroupOnlyExpiryTooltip = (props) => {
    return (
        <ReactTooltip
            id={`${props.context.gridId}-group-only-expiry`}
            className="fort-grid-tooltip"
            border={true}
            place="right"
            type="light"
            multiline={true}
            html={true}
            getContent={(rowIndex) => {
                if (props.getRowDataCallback) {
                    const rowNode = props.getRowDataCallback(Number(rowIndex));

                    if (rowNode) {
                        return generateGroupOnlyTooltip(
                            rowNode.data,
                            props.userTimezone
                        );
                    }
                }
                return null;
            }}
        />
    );
};

const mapStateToProps = (state, props) => {
    const { userTimezone } = state.user;
    return {
        ...props,
        userTimezone,
    };
};

export default connect(mapStateToProps)(GroupOnlyExpiryTooltip);
